import React from "react";

function WorkTableLine({ year, siteName, deliveryItems }) {
  return (
    <tr>
      <td>{year}</td>
      <td>{siteName}</td>
      <td>{deliveryItems}</td>
    </tr>
  );
}

export default WorkTableLine; 